/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Restriction } from './Restriction';
import {
    RestrictionFromJSON,
    RestrictionFromJSONTyped,
    RestrictionToJSON,
} from './Restriction';

/**
 * 
 * @export
 * @interface RestrictionPage
 */
export interface RestrictionPage {
    /**
     * 
     * @type {Array<Restriction>}
     * @memberof RestrictionPage
     */
    restrictions: Array<Restriction>;
    /**
     * 
     * @type {number}
     * @memberof RestrictionPage
     */
    totalNr: number;
    /**
     * 
     * @type {string}
     * @memberof RestrictionPage
     */
    asOfDate: string;
}

/**
 * Check if a given object implements the RestrictionPage interface.
 */
export function instanceOfRestrictionPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "restrictions" in value;
    isInstance = isInstance && "totalNr" in value;
    isInstance = isInstance && "asOfDate" in value;

    return isInstance;
}

export function RestrictionPageFromJSON(json: any): RestrictionPage {
    return RestrictionPageFromJSONTyped(json, false);
}

export function RestrictionPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): RestrictionPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'restrictions': ((json['restrictions'] as Array<any>).map(RestrictionFromJSON)),
        'totalNr': json['total_nr'],
        'asOfDate': json['as_of_date'],
    };
}

export function RestrictionPageToJSON(value?: RestrictionPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'restrictions': ((value.restrictions as Array<any>).map(RestrictionToJSON)),
        'total_nr': value.totalNr,
        'as_of_date': value.asOfDate,
    };
}

